import { render, staticRenderFns } from "./vehicleOwnership.vue?vue&type=template&id=e9f801b6&scoped=true&"
import script from "./vehicleOwnership.vue?vue&type=script&lang=js&"
export * from "./vehicleOwnership.vue?vue&type=script&lang=js&"
import style0 from "./vehicleOwnership.vue?vue&type=style&index=0&id=e9f801b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f801b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f801b6')) {
      api.createRecord('e9f801b6', component.options)
    } else {
      api.reload('e9f801b6', component.options)
    }
    module.hot.accept("./vehicleOwnership.vue?vue&type=template&id=e9f801b6&scoped=true&", function () {
      api.rerender('e9f801b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/detail/vehicleOwnership.vue"
export default component.exports